import type from '../actions/types';
import { ProviderState } from '../../models/interfaces';
import { ActionType } from '../../../../models/types';

const INITIAL_STATE: ProviderState = {
  listProviders: [],
  isLoading: false,
}

function reducer(state: ProviderState = INITIAL_STATE, action: ActionType) {
  switch (action.type) {
    case type.SET_PROVIDERS:
      return {
        ...state,
        listProviders: action.payload
      };
      case type.SET_LOADING_PROVIDERS:
        return {
          ...state,
          isLoading: action.payload
        };
    default:
      return state;
  }
}

export default reducer;